export const BASIC_POLYFILL_PATH = process.env.BASIC_POLYFILL_PATH || "";

export const INTERSECTION_OBSERVER_POLYFILL_PATH =
  process.env.INTERSECTION_OBSERVER_POLYFILL_PATH || "";

export const RESIZE_OBSERVER_POLYFILL_PATH =
  process.env.RESIZE_OBSERVER_POLYFILL_PATH || "";
